import { createContext } from 'react';

import { type ChartContextValue } from './useChart.schema';

export const ChartContext = createContext<ChartContextValue | null>(null);
